const useKeyPressHandler = (onClick: (() => void) | string, onKeyUp?: (letterKey?: string) => void) => {
  const onKeyPressHandler = (e: React.KeyboardEvent) => {
    if ((e.key === 'Enter' || e.key === ' ') && typeof onClick !== 'string') {
      onClick();
    } else if (e.key !== 'Tab' && typeof onClick !== 'string' && onKeyUp !== undefined) {
      onKeyUp(e.key);
    }
  };

  return {
    onKeyPressHandler,
  };
};

export default useKeyPressHandler;
